"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _constant = require("../constant");

var _utilities = _interopRequireDefault(require("../../utilities"));

var _constant2 = require("./constant");

var _stepperButton = _interopRequireDefault(require("./stepperButton.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var CustomIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "StepperButton__CustomIcon",
  componentId: "sc-obb74q-0"
})([""]);
var HoverStyle = (0, _styledComponents.css)(["&:hover{background-color:", ";}&:hover ", "{color:", ";}"], function (_ref) {
  var theme = _ref.theme,
      hoverColor = _ref.hoverColor;
  return theme.backgroundColor[hoverColor];
}, CustomIcon, function (props) {
  return props.theme.colors[props.hoverIconColor];
});
var DisabledStyle = (0, _styledComponents.css)(["pointer-events:all;cursor:not-allowed !important;background-color:", ";& ", "{color:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.backgroundColor[_constant2.DEFAULT_STYLE.DISABLED.BACKGROUND_COLOR];
}, CustomIcon, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors[_constant2.DEFAULT_STYLE.DISABLED.ICON_COLOR];
});
var StyledStepperButton = (0, _styledComponents.default)(function (_ref4) {
  var className = _ref4.className,
      onStepperClicked = _ref4.onStepperClicked,
      icon = _ref4.icon,
      ariaLabel = _ref4.ariaLabel,
      tabIndex = _ref4.tabIndex,
      customProperties = _ref4.customProperties,
      paxType = _ref4.paxType,
      isIncrement = _ref4.isIncrement;
  var id = '';

  if (isIncrement) {
    if (paxType === 'adult') {
      id = 'home_adult_add';
    }

    if (paxType === 'child') {
      id = 'home_child_add';
    }

    if (paxType === 'infant') {
      id = 'home_infant_add';
    }
  } else {
    if (paxType === 'adult') {
      id = 'home_adult_remove';
    }

    if (paxType === 'child') {
      id = 'home_child_remove';
    }

    if (paxType === 'infant') {
      id = 'home_infant_remove';
    }
  }

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    id: id,
    className: className,
    tabIndex: tabIndex,
    onClick: onStepperClicked,
    onKeyDown: function onKeyDown(e) {
      return _utilities.default.keyDownHandler(e, onStepperClicked, _constant.KEY_CODE.ENTER);
    },
    role: "button",
    "aria-label": ariaLabel
  }, customProperties), /*#__PURE__*/_react.default.createElement(CustomIcon, {
    icon: icon,
    fontsiz: true,
    e: "titleNormal",
    color: "secondary",
    accessible: false
  }));
}).withConfig({
  displayName: "StepperButton__StyledStepperButton",
  componentId: "sc-obb74q-1"
})(["display:flex;align-items:center;justify-content:center;width:32px;height:32px;background:", ";box-shadow:0px 2px 4px rgba(0,0,0,0.25);border-radius:", ";border:", ";cursor:pointer;", " ", ""], function (props) {
  return props.theme.backgroundColor[props.backgroundColor];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius.small;
}, function (_ref6) {
  var theme = _ref6.theme,
      disabled = _ref6.disabled;
  return !disabled && "1px solid ".concat(theme.colors.secondary);
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return !disabled && HoverStyle;
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled && DisabledStyle;
});

var StepperButton = function StepperButton(props) {
  var theme = props.theme,
      disabled = props.disabled,
      onStepperClicked = props.onStepperClicked,
      backgroundColor = props.backgroundColor,
      enableHover = props.enableHover,
      hoverColor = props.hoverColor,
      hoverIconColor = props.hoverIconColor,
      customProperties = props.customProperties,
      stepperType = props.stepperType,
      accessible = props.accessible,
      className = props.className,
      paxType = props.paxType,
      isIncrement = props.isIncrement;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';
  var buttonIcon = '';
  var ariaLabel = '';

  if (stepperType === _constant2.STEPPER_BUTTON_TYPE.MINUS) {
    buttonIcon = _constant2.DEFAULT_STYLE.STEPPER_BUTTON_MINUS_ICON;
    ariaLabel = 'minus-button';
  } else {
    buttonIcon = _constant2.DEFAULT_STYLE.STEPPER_BUTTON_PLUS_ICON;
    ariaLabel = 'plus-button';
  }

  var handleStepperClick = function handleStepperClick() {
    if (!disabled && onStepperClicked) onStepperClicked();
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(StyledStepperButton, {
      id: "stepper-button",
      onStepperClicked: function onStepperClicked(e) {
        return handleStepperClick(e);
      },
      backgroundColor: backgroundColor,
      enableHover: enableHover,
      hoverColor: hoverColor,
      hoverIconColor: hoverIconColor,
      disabled: disabled,
      icon: buttonIcon,
      ariaLabel: ariaLabel,
      theme: themeContext,
      customProperties: customProperties,
      tabIndex: tabIndex,
      className: className,
      paxType: paxType,
      isIncrement: isIncrement
    });
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

StepperButton.propTypes = _stepperButton.default.PropTypes;
StepperButton.defaultProps = _stepperButton.default.DefaultProps;
var _default = StepperButton;
exports.default = _default;